<template>
  <div class="plk-basic-container">
    <ObjectLoader :object="object" :connection="object.connection" :plkparams="object.plkparams" :instance="getInstance(object.type)" v-for="(object, index) in componentsWithInstance" :key="`${Math.random()}-${index}`"/>
  </div>
</template>

<script>
import services from '@/services'
import configuration from './package.json'
import readme from './README.md'
import ObjectLoaderViewer from '@/views/Viewer/ObjectLoader/Index'
import ObjectLoaderDesign from '@/views/Design/components/ObjectLoader/Index'
export const TYPE = services.component.normalizeType('BasicContainer')

export default {
  name: TYPE,
  data () {
    return {
      instances: {}
    }
  },
  components: {
    ObjectLoader: window.PLKDesign ? ObjectLoaderDesign : ObjectLoaderViewer
  },
  computed: {
    components () {
      return (this.plkparams.components || [])
    },
    componentsWithInstance () {
      return this.components.filter(object => this.getInstance(object.type))
    }
  },
  methods: {
    async onInitComponent () {
      this.components.forEach(component => {
        if (!this.getInstance(component.type)) {
          this.$servicesPLK.component.loadComponent(component.type, this.instances, this.normalizeType(component.type))
        }
      })
    },
    normalizeType (type) {
      return this.$servicesPLK.component.normalizeType(type)
    },
    getInstance (type) {
      return this.instances[this.normalizeType(type)]
    },
    getPackage () {
      return configuration
    },
    getReadme () {
      return readme
    }
  }
}
</script>

<style lang="scss">
</style>
